
    import { injectNav, injectFooter } from './src/scripts/layout.js';
    import { initScrollAnimations } from './src/scripts/animations.js';
    document.addEventListener('DOMContentLoaded', () => {
      injectNav();
      injectFooter();
      initScrollAnimations();

      // FAQ accordion toggle
      document.querySelectorAll('.faq-question').forEach(q => {
        q.addEventListener('click', () => {
          q.closest('.faq-item').classList.toggle('open');
        });
      });
    });
  